import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const DrAnuradhaTikheDietitianContent = () => {
  return (
    <DoctorDetailPage
      name="Dr. Anuradha Tikhe"
      specialization="Your Steady Hand & Reassuring Voice"
      experience="16+ Years specializing in Pregnancy Nutrition"
      degrees="BHMS, MPH (Mumbai), Certified Pregnancy Nutritionist, Certificate Of Prenatal & Postnatal Yoga"
      quote="I believe I am becoming a pregnancy crafter who brings calm experience to every decision."
      sections={[
        {
          title: "My Philosophy on Pregnancy Care",
          body: "Having been a doctor for many years, I've learned that my most important tool is listening. I provide a foundation of stability and experience. My approach is calm, patient, and methodical. In moments of panic or uncertainty, my job is to be the anchor: to reassure you with the confidence that comes from having safely navigated these waters many, many times before.",
        },
        {
          title: "Why I Chose Myprega",
          body: "I joined Myprega because I see it as the perfection of the patient-doctor relationship. After decades in the field, I can say with certainty that their model of continuous, empathetic support is what mothers have always needed. Myprega allows me to share my years of experience in a more meaningful and personal way than ever before.",
        },
        {
          title: "Beyond the Clinic",
          body: "I am an amateur photographer, with a focus on landscapes. It teaches me patience and the art of observation. My wife and I enjoy long walks, and I find that the rhythm of walking is when I do my best thinking.",
        },
      ]}
      favorites={[
        { icon: "📖", label: "Favourite Book", value: "The Art of Seeing - Aldous Huxley" },
        { icon: "🎵", label: "Favourite Singer", value: "Kumar Gandharva" },
        { icon: "📸", label: "Favourite Pastime", value: "Landscape Photography\nLong Walks with My Wife" },
      ]}
    />
  );
};

export default DrAnuradhaTikheDietitianContent;
